<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: isEdit ? 'ویرایش فروشگاه' : 'افزودن فروشگاه جدید', icon: isEdit ? 'pencil' : 'store-plus' }"
    :loading="loading"
    max-width="700"
    hide-confirm
    persistent
  >
    <div class="pa-4">
      <p class="text-caption grey--text text--darken-1 mb-6">
        {{ isEdit ? 'ویرایش اطلاعات فروشگاه انتخاب شده.' : 'ابتدا نوع فروشگاه خود را انتخاب کرده و سپس اطلاعات مورد نیاز را وارد نمایید.' }}
      </p>

      <!-- دراپ‌داون نوع فروشگاه با آیکون‌های SVG اختصاصی -->
      <v-select
        v-model="selectedStoreType"
        :items="storeTypes"
        item-text="title"
        item-value="value"
        label="انتخاب نوع فروشگاه"
        outlined
        dense
        class="rounded-lg"
        hide-details="auto"
        :readonly="isEdit"
      >
        <!-- نمایش آیتم انتخاب شده داخل فیلد -->
        <template v-slot:selection="{ item }">
          <StoreBrandBadge :type="item.value" :label="item.title" :size="20" />
        </template>

        <!-- نمایش آیتم‌ها درون لیست بازشو -->
        <template v-slot:item="{ item }">
          <div class="py-1">
            <StoreBrandBadge :type="item.value" :label="item.title" :size="22" />
          {{ item.title }}
          </div>
        </template>
      </v-select>

      <v-slide-y-transition mode="out-in">
        <component
          v-if="selectedStoreType"
          :is="currentFormComponent"
          ref="formComponent"
          class="mt-4"
          @valid="isFormValid = $event"
        />
      </v-slide-y-transition>

      <div class="d-flex align-center justify-end mt-8">
        <v-btn text class="btn-delete rounded-lg" @click="closePopup" :disabled="loading">
          <v-icon left>mdi-close</v-icon>
          انصراف
        </v-btn>
        <v-spacer/>
        
        <v-btn
          v-if="selectedStoreType !== 'divar'"
          class="btn-get-code rounded-lg"
          :loading="loading"
          :disabled="!isFormValid"
          @click="submitStore"
        >
          <v-icon left>mdi-check</v-icon>
          {{ isEdit ? 'ذخیره تغییرات' : ((selectedStoreType === 'physical_store' || selectedStoreType === 'store') ? 'ثبت فروشگاه' : 'اتصال و افزودن') }}
        </v-btn>
      </div>
    </div>
  </custom-popup>
</template>

<script>
import DigikalaForm from "./forms/DigikalaForm";
import WooForm from "./forms/WooForm";
import PhysicalStoreForm from "./forms/PhysicalStoreForm";
import DivarForm from "@/view/pages/numbers/addNewNumbers2";
import StoreBrandBadge from "./StoreBrandBadge.vue";

export default {
  name: "AddOnlineStore",
  components: {
    DigikalaForm,
    WooForm,
    PhysicalStoreForm,
    DivarForm,
    StoreBrandBadge
  },
  props: { 
    value: Boolean,
    isEdit: { type: Boolean, default: false },
    storeId: { type: [Number, String], default: null }
  },
  data: () => ({
    loading: false,
    selectedStoreType: null,
    isFormValid: false,
    storeTypes: [
      { title: "دیجی‌کالا", value: "digikala" },
      { title: "فروشگاه ووکامرس", value: "woocommerce" },
      { title: "دیوار", value: "divar" },
      { title: "فروشگاه فیزیکی", value: "physical_store" }
    ]
  }),
  computed: {
    dialog: {
      get() { return this.value },
      set(val) { this.$emit("input", val) }
    },
    currentFormComponent() {
      const map = {
        digikala: 'DigikalaForm',
        woocommerce: 'WooForm',
        divar: 'DivarForm',
        store: 'PhysicalStoreForm',
        physical_store: 'PhysicalStoreForm'
      };
      return map[this.selectedStoreType];
    }
  },
  watch: {
    value(val) {
      if (val && this.isEdit && this.storeId) {
        this.fetchStoreDetails();
      }
    }
  },
  methods: {
    async fetchStoreDetails() {
      this.loading = true;
      try {
        const res = await this.$api.get(`v1/store/${this.storeId}`);
        if (res.data?.data) {
          const storeData = res.data.data;
          this.selectedStoreType = storeData.type === 'store' ? 'physical_store' : storeData.type;
          
          this.$nextTick(() => {
            if (this.$refs.formComponent && this.$refs.formComponent.setData) {
              this.$refs.formComponent.setData(storeData);
            }
          });
        }
      } catch (err) {
        this.$toast?.error?.("خطا در دریافت اطلاعات فروشگاه");
      } finally {
        this.loading = false;
      }
    },

    async submitStore() {
      const payload = this.$refs.formComponent.getData();
      this.loading = true;
      
      try {
        if (this.isEdit) {
          await this.$api.put(`v1/store/${this.storeId}`, payload);
          this.$toast?.success?.("فروشگاه با موفقیت ویرایش شد");
        } else {
          await this.$api.post(`v1/store`, payload);
          this.$toast?.success?.("فروشگاه با موفقیت افزوده شد");
        }
        this.$emit("refresh");
        this.closePopup();
      } catch (err) {
        this.$toast?.error?.(err.response?.data?.message || "خطا در عملیات");
      } finally {
        this.loading = false;
      }
    },
    
    closePopup() {
      this.dialog = false;
      this.selectedStoreType = null;
      this.$emit("close");
    }
  }
};
</script>
